<ion-app [class]="backgroundClass">
    <div id="app-wrapper" class="app-wrapper">
        <app-header *ngIf="showHeader"></app-header>
        <div id="app-inner">
            <ion-router-outlet id="main-content"></ion-router-outlet>
        </div>
        <app-footer-mobile *ngIf="showHeader"></app-footer-mobile>
    </div>
    <app-cookie-banner></app-cookie-banner>
</ion-app>
